import { Injectable } from '@angular/core';
import { EntryConfigInterface, PageConfigInterface } from '@ptl/forms';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { IndividualMarketStateStructure } from '../../plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';

@Injectable({
  providedIn: 'root'
})
export class AddControlService {
  //'closeHyperlink',
  spouseControlNames = ["dobSpouse", "genderSpouse", "tobaccoUseSpouse"];
  dependentControlNames = ["dobDependent", "genderDependent", "tobaccoUseDependent"];
  public activeCloseAction: String;


  constructor(private ngRedux: NgRedux<StateStructure>, private reducerUtilService: ReducerUtilityService) { }

  addControls(entry: EntryConfigInterface, count: number, currentPage: PageConfigInterface, form?: UntypedFormGroup): number {
    let order = entry.order;
    const insertIndex = entry.order;
    let closeFormControlName = '';
    for (const obj of entry.custom.entries) {

      const newEntry = JSON.parse(JSON.stringify(obj));
      newEntry.order = order;
      if (newEntry.formControlAttributes && newEntry.formControlAttributes.formControlName) {
        let newFormControlName = '';
        let newGetValueFromState = '';
        if (entry.custom.hideAddControl) {
          newFormControlName = `${newEntry.formControlAttributes.formControlName}`;
        } else {
          newFormControlName = `${newEntry.formControlAttributes.formControlName}-${count}`;
          newGetValueFromState = `${newEntry.formControlAttributes.getValueFromState}-${count}`;
          if (newEntry.base && newEntry.base.formListeners) {
            for (const obj1 of newEntry.base.formListeners) {
              if (obj1.listenToFormControls) {
                let i = 0;
                for (const obj2 of obj1.listenToFormControls) {
                  const newVal = `${obj2}-${count}`;
                  obj1.listenToFormControls[i] = newVal;
                  i++;
                }
              }
            }
          }
        }
        newEntry.formControlAttributes.formControlName = newFormControlName;
        newEntry.formControlAttributes.getValueFromState = newGetValueFromState;  //setting Dyanmic State names from store

        const disabled = newEntry.formControlAttributes && newEntry.formControlAttributes.disabled;

        if (form) {
          if (newEntry.base.componentType === 'date-input') {
            form.addControl(newFormControlName, new UntypedFormControl({ value: moment(), disabled: disabled }));
          } else {
            form.addControl(newFormControlName, new UntypedFormControl({ value: null, disabled: disabled }));
          }

        }
      }

      /* for handling active close icon name */
      if (newEntry?.base?.componentType === 'section-header') {
        this.activeCloseAction = `reset-${newEntry.base.text}-${count}`;
      }

      currentPage.entries.splice(newEntry.order, 0, newEntry);
      order++;
    }
    count++;
    // this.ngRedux.dispatch(updateCount(count));
    // currentPage.custom.dynamicControls.currentCount++;
    // if (this.noOfDependentsIncludingPartnerOrSpouse() < currentPage.custom.dynamicControls.currentCount) {
    //   this.ngRedux.dispatch(updateCount(currentPage.custom.dynamicControls.currentCount));
    // }
    entry.order = order;
    // update the subsuquent orders as well
    for (let i = insertIndex + entry.custom.entries.length; i < currentPage.entries.length; i++) {
      currentPage.entries[i].order = i;
    }
    for (const e of currentPage.entries) {
      if (e.base.componentType === 'add-controls' &&
        e.custom.commonControlName === entry.custom.commonControlName &&
        e.custom.hideAddControl) {
        e.base.display = false;
      }
    }
    if (count === currentPage.custom.dynamicControls.maxCount) {
      for (const e of currentPage.entries) {
        if (e.base.componentType === 'add-controls') {
          e.base.display = false;
        }
      }
    }
    return count;
  }


  removeControl(entry, currentPage: PageConfigInterface, resetActionName: String, form?: UntypedFormGroup,) {

    const currentPageEntries = currentPage.entries.slice(0);
    let actionItemName = "spouse";
    const count = resetActionName.split("-")[2];

    if (resetActionName.includes('Domestic Partner Details')) {
      actionItemName = "partner";
    } else if (resetActionName.includes('Dependent Details')) {
      actionItemName = "dependents";
    }

    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilService.getPayloadState('individualMarket');
    if (actionItemName === 'spouse') {
      const baseTextIndex = currentPage.entries.findIndex(x => x?.base?.text === 'Spouse Details');

      currentPage.entries.splice(baseTextIndex, 5);

      currentPage.entries[baseTextIndex].base.display = true;
      currentPage.entries[baseTextIndex + 1].base.display = true;
      delete individualMarketPayload.individualMarketEligibility.dobSpouse;
      delete individualMarketPayload.individualMarketEligibility.genderSpouse;
      delete individualMarketPayload.individualMarketEligibility.tobaccoUseSpouse;

      delete form.controls.dobSpouse;
      delete form.controls.genderSpouse;
      delete form.controls.tobaccoUseSpouse;
    } else if (actionItemName === 'partner') {
      const baseTextIndex = currentPage.entries.findIndex(x => x?.base?.text === 'Domestic Partner Details');
      currentPage.entries.splice(baseTextIndex, 5);
      currentPage.entries[baseTextIndex].base.display = true;
      currentPage.entries[baseTextIndex - 1].base.display = true;

      delete individualMarketPayload.individualMarketEligibility.dobPartner;
      delete individualMarketPayload.individualMarketEligibility.genderPartner;
      delete individualMarketPayload.individualMarketEligibility.tobaccoUsePartner;

      delete form.controls.dobPartner;
      delete form.controls.genderPartner;
      delete form.controls.tobaccoUsePartner;
    } else {

      const fieldIndex = currentPage.entries.findIndex(x => x?.formControlAttributes?.formControlName === `closeHyperlink-${count}`);
      currentPage.entries.splice(fieldIndex - 1, 5);

      delete individualMarketPayload.individualMarketEligibility[`dobDependent-${count}`];
      delete individualMarketPayload.individualMarketEligibility[`genderDependent-${count}`];
      delete individualMarketPayload.individualMarketEligibility[`tobaccoUseDependent-${count}`];

      delete form.controls[`dobDependent-${count}`];
      delete form.controls[`genderDependent-${count}`];
      delete form.controls[`tobaccoUseDependent-${count}`]
    }

    currentPage.entries.forEach((entry, index) => {
      entry.order = index;
    })

  }

  isSpouseAlreadyAdded() {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilService.getPayloadState('individualMarket');
    const individualMarketEligibility = individualMarketPayload.individualMarketEligibility;
    if (individualMarketEligibility.dobSpouse || individualMarketEligibility.genderSpouse) {
      return true;
    }
    return false;
  }

  isPartnerAlreadyAdded() {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilService.getPayloadState('individualMarket');
    const individualMarketEligibility = individualMarketPayload.individualMarketEligibility;
    if (individualMarketEligibility.dobPartner || individualMarketEligibility.genderPartner) {
      return true;
    }
    return false;
  }

  noOfDependents(): number {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilService.getPayloadState('individualMarket');
    const individualMarketEligibility = individualMarketPayload.individualMarketEligibility;
    if (this.isSpouseAlreadyAdded() || this.isPartnerAlreadyAdded()) {
      return --individualMarketEligibility.count;
    }
    return individualMarketEligibility.count;
  }

  noOfDependentsIncludingPartnerOrSpouse(): number {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilService.getPayloadState('individualMarket');
    const individualMarketEligibility = individualMarketPayload.individualMarketEligibility;
    return individualMarketEligibility.count;
  }
}
